import React, { Component } from 'react';
import { Row, Table, DatePicker, Button, Spin, message, Popconfirm } from "antd";
import moment from "moment";
import FileSaver from "file-saver";
import './index.scss';

const { MonthPicker } = DatePicker;

class index extends Component {
    constructor(props) {
        super(props);
        const user = JSON.parse(sessionStorage.getItem('user') || "{}");
        this.state = {
            date: window.location.hash.includes('/bp/') || user.is_charter == 1 ? moment().add(1, 'y').format('YYYY-MM') : moment().subtract(1, 'month').format('YYYY-MM'),
            data: [],
            loading: true,
            selectedRowKeys: [],
            exportLoading: false
        }
    }

    componentDidMount() {
        this.getData(this.state.date);
    }


    getData = (date) => {
        const user = JSON.parse(sessionStorage.getItem('user') || "{}");
        this.setState({ loading: true });
        let url = window.location.hash.includes('/bp/') || user.is_charter == 1 ? `/getPdf_bp?year=${moment(date).format('YYYY')}&sort=` : `/getPdf?year=${moment(date).format('YYYY')}&month=${moment(date).format('MM')}&sort=`;
        if (window.location.hash.includes('/hr/')) {
            url = `/getPdf_hr?year=${moment(date).format('YYYY')}&month=${moment(date).format('MM')}&sort=`
        }
        fetch(url, { credentials: 'include' }).then(x => x.json()).then(x => {
            this.setState({ data: (x.data || []).sort((a, b) => Number(a.sort) - Number(b.sort)), loading: false });
        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }

    onSelectChange = (selectedRowKeys) => {
        this.setState({ selectedRowKeys });
    }

    onExport = () => {
        const selectedRowKeys = this.state.selectedRowKeys;
        this.setState({ exportLoading: true });

        let type = 1;
        const hostName = window.location.hash;
        if (hostName.includes('/bp')) {
            type = 2;
        } else if (hostName.includes('/hr')) {
            type = 3;
        }

        fetch(`/customizeExport?id=${selectedRowKeys.toString()}&type=${type}`, { credentials: 'include' }).then(x => x.blob()).then(x => {
            this.setState({ exportLoading: false });
            let file = new Blob([x], { type: "application/pdf" });
            FileSaver.saveAs(file, `${moment(this.state.date).format('YYYY-MM')}.pdf`);
            message.info('导出成功！')
        }).catch(err => {
            console.error(err);
            this.setState({ exportLoading: false });
            message.info('导出失败！')
        })
    }

    onDeltePdf = async (record) => {
        try {

            const user = JSON.parse(sessionStorage.getItem('user') || "{}");

            if (user.id != record.user_id && !['admin', 'GM', 'EAM'].some(x => user.email.includes(x))) {
                message.error('非此pdf添加人员不可删除!');
                return
            }

            let url = `/deletepdf?id=${record.id}&name=`;
            switch (window.location.hash) {
                case "#/table/pdf":
                    url += `es`;
                    break;
                case "#/hr/pdf":
                    url += `hr`;
                    break;
                case "#/bp/pdf":
                    url += `bp`;
                    break;

                default:
                    break;
            }
            const res = await fetch(url, { credentials: 'include' });
            const json = await res.json();

            if (json.status == 1) {
                message.success('删除成功！');
                this.getData(this.state.date);
                return
            }
            message.error(json.msg);

        } catch (error) {
            console.error(error);
            message.error('删除失败！');
        }
    }

    render() {
        const { selectedRowKeys, exportLoading } = this.state;
        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
        };

        const columns = [{
            title: '表格',
            dataIndex: 'sort',
            key: 'sort',
        }, {
            title: '图片',
            dataIndex: 'img',
            key: 'img',
            render: (text) => {
                return (
                    <img src={text.replace('-internal', '')} style={{ height: 40 }} />
                )
            }
        }, {
            title: '年份',
            dataIndex: 'year',
            key: 'year',
            render: (text, record, index) => {
                return (
                    <span>{text}{record.month ? `-${record.month}` : record.month}</span>
                )
            }
        }, {
            title: '添加时间',
            dataIndex: 'add_time',
            key: 'add_time',
        }, {
            title: '操作',
            dataIndex: 'action',
            key: 'action',
            render: (text, record, index) => {
                return (
                    <span>
                        <Popconfirm
                            title="确定删除这张pdf吗?"
                            onConfirm={this.onDeltePdf.bind(this, record)}
                            okText="确定"
                            cancelText="取消"
                        >
                            <a href="javascript:;" >删除</a>
                        </Popconfirm>

                    </span>
                )
            }
        }];
        let title = window.location.hash.includes('/bp/') ? 'Business Plan - ' : window.location.hash.includes('/hr/') ? "Human Resources" : 'Executive Summary Version - ';
        let user = {};
        try {
            user = JSON.parse(sessionStorage.getItem('user') || "{}");
            if (user.is_charter == 1) title = 'DATA INPUT 数据输入';
        } catch (error) {
            console.error(error);
        }
        return (
            <Spin tip="表格导出中，请稍后..." spinning={exportLoading}>
                <div className="pdf">
                    <Row className="title">
                        {title} 已添加PDF列表
                </Row>
                    <Row style={{ marginTop: 20 }}>
                        <MonthPicker
                            placeholder="请选择年月"
                            monthCellContentRender={(date, local) => {
                                return moment(date).format('M月')
                            }}
                            defaultValue={moment(this.state.date, "YYYY-MM")}
                            format="YYYY-MM"
                            onChange={(date, str) => {
                                this.getData(str);
                            }}
                        />
                        <Button type="primary" className="export-pdf" onClick={this.onExport} loading={exportLoading}>导出pdf</Button>
                    </Row>
                    <Row className="table-content">
                        <Table
                            dataSource={this.state.data}
                            columns={columns}
                            bordered
                            rowKey={record => record.id}
                            loading={this.state.loading}
                            rowSelection={rowSelection}
                        />
                    </Row>
                </div>
            </Spin>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/pdf/index.js